import { Box, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { FC, useState } from 'react';
import Button from '../../button';
import useModal from '../../../hooks/use-modal.hook';
import Modal from '..';
import InlineToast from '@/components/toasts/inline';
import Text from '@/components/text';
import { OrgPolicyEngine } from '@/lib/models/org.model';
import { patchOrgPolicyEngine } from '@/lib/services/org.service';

export interface Props {
  orgId: string;
  orgName: string;
  policyEngine: OrgPolicyEngine;
  onReverted: (policyEngine: OrgPolicyEngine) => void;
}

export const PolicyEngineRevertModal: FC<Props> = ({
  orgId,
  orgName,
  policyEngine: current,
  onReverted,
}) => {
  const { closeModal } = useModal();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleRevert = async () => {
    setSaving(true);
    setError('');

    // v1 ignores the merge strategy, but the API requires it, so keep the current one.
    const policyEngine: OrgPolicyEngine = { version: 'v1', mergeStrategy: current.mergeStrategy };
    const { patched, error } = await patchOrgPolicyEngine(orgId, policyEngine);

    setSaving(false);

    if (!patched) {
      setError(error || 'The policy engine was not changed');
      return;
    }

    onReverted(policyEngine);
    closeModal();
  };

  return (
    <Modal preventClose={saving}>
      <DialogTitle>Switch Back to Policy Engine v1</DialogTitle>
      <DialogContent>
        <Stack gap={2}>
          <Box>
            <Text bold inline>
              {orgName}
            </Text>{' '}
            will use its v1 policies again. Its v2 policies stay, so you can examine them. The next
            switch to v2 replaces them with a new conversion.
          </Box>

          <InlineToast
            level="warning"
            message="Changes made to v2 policies do not apply to v1 policies."
          />

          {error && <InlineToast level="error" message={error} />}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button label="Cancel" type="cancel" onClick={() => closeModal()} disabled={saving} />
        <Button label="Switch Back to v1" onClick={() => void handleRevert()} loading={saving} />
      </DialogActions>
    </Modal>
  );
};

export default PolicyEngineRevertModal;
